export default __webpack_public_path__ + "static/media/survey-bg.753db431.jpg";